<div class="testimonial-carousel">
  <p>{{ testimonials[currentIndex].comment }}</p>
  <div class="testimonial">
    <img [src]="testimonials[currentIndex].image !==null ? testimonials[currentIndex].image : 'https://1.bp.blogspot.com/-FwGEkRrvXAM/VPyg1smmIqI/AAAAAAAAJEM/uVRL7b9PTZ4/s1600/ratatouille-cuchara.jpg' " alt="{{ testimonials[currentIndex].name }}" style="width: 60px;">
    <div class="titanInformation">
      <p class="testimonial-name">{{ testimonials[currentIndex].name }}</p>
      <p class="testimonial-age">{{ testimonials[currentIndex].age }}</p>
    </div>
  </div>
</div>
<div class="dots">
  <span class="dot" *ngFor="let testimonial of testimonials; let i = index" (click)="goToTestimonial(i)" [class.active]="i === currentIndex"></span>
</div>
